import { render } from "./form1.vue?vue&type=template&id=e0c41940&scoped=true"
import script from "./form1.vue?vue&type=script&lang=js"
export * from "./form1.vue?vue&type=script&lang=js"

import "./form1.vue?vue&type=style&index=0&id=e0c41940&lang=less&scoped=true"

import exportComponent from "/Users/a/k618/work/sxdsjtj/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0c41940"]])

export default __exports__